"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PieChartSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M8.5,1 C12.6421356,1 16,4.35786438 16,8.5 C16,12.6421356 12.6421356,16 8.5,16 C4.35786438,16 1,12.6421356 1,8.5 C1,4.35786438 4.35786438,1 8.5,1 Z M2,8.5 C2,11.9218429 4.64412846,14.7261164 8.00067087,14.9811062 L8.00067087,2.01889382 C4.64412846,2.27388358 2,5.07815715 2,8.5 Z M14.9810299,9.00033196 L9,9 L9.00033196,14.9810299 C12.191269,14.7381279 14.7381279,12.191269 14.9810299,9.00033196 Z M9.00033196,2.01897008 L9,8 L14.9811062,8.00067087 C14.7386615,4.8092646 12.1916033,2.26189756 9.00033196,2.01897008 Z" })));
};
PieChartSmall.displayName = 'PieChartSmall';
exports.default = PieChartSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PieChartSmall.js.map